import { useNavigate } from 'react-router-dom';
import { SupplierManagement } from '../components/features';

const Suppliers = () => {
  const navigate = useNavigate();

  return <SupplierManagement onNavigate={(view) => navigate(`/${view}`)} />;
};

export default Suppliers;
